import "./App.css";
import ProtectedRoute from "./utils/protectedRoute";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
    return (
        <>
            <Router>
                <ProtectedRoute />
            </Router>
        </>
    );
}

export default App;
